var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_28142)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6575 5.04166C21.6181 2.03907 29.8728 3.49555 35.4056 9.05259C42.7679 16.447 42.7679 28.4126 35.4056 35.7846C29.8728 41.3417 21.5958 42.7981 14.6575 39.7955C22.1982 43.9409 31.7468 42.7085 38.0159 36.412C45.7351 28.6815 45.7351 16.1333 38.0382 8.42518C31.7691 2.10629 22.1982 0.896289 14.6575 5.04166Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6563 30.4292L30.8099 24.0207H28.155H22.8007V5.69141L22.9345 5.84826C24.9424 8.35789 26.9503 10.8675 28.9805 13.3771L32.974 18.3516H28.8689L25.6563 14.3855V20.3907H28.3112H33.9556H34.5356L36.2089 22.4297L22.8007 39.1457V26.0821H25.6563V30.4292Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1379 14.3631L11.6904 22.4073L18.1379 30.4516V14.3631ZM21.0159 39.1233L7.60767 22.4073L14.8584 13.3771L20.9043 5.84826L21.0382 5.69141V39.1233H21.0159Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5094 41.7897C25.5447 45.5094 15.9292 43.9184 9.52627 37.5099C1.227 29.1744 1.227 15.6403 9.52627 7.30473C15.9069 0.89621 25.5447 -0.694716 33.5094 3.02491C24.8978 -1.99435 13.7875 -0.717123 6.53675 6.56528C-2.1864 15.3266 -2.1864 29.5105 6.53675 38.2494C13.7875 45.5318 24.8978 46.809 33.5094 41.7897Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_28142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.7943,
    height: 44.8148,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a7f1507a305fc4158ad5df6eedf2493b.svg";
export { ForwardRef as ReactComponent };